export const DUE_DATE_DAYS_FORWARD_REVIEW = 5;
export const DUE_DATE_DAYS_FORWARD_SEARCH_BOOK = 10;
export const MEETING_DATE_DAYS_FORWARD = 0;
export const MIN_STRATEGIES = 2;
export const MAX_STRATEGIES = 12;
export const MIN_BENCHMARKS = 1;
export const MAX_BENCHMARKS = 4;
export const MIN_FPL_STRATEGIES = 1;
export const JOB_STATUS_NEW = 'New';
export const JOB_STATUS_DEFAULT_ACTIVE = 'Active';
export const JOB_STATUS_COMPLETED = 'Job Completed';
export const JOB_STATUS_SB_GENERATED = 'SearchBook Generated';
export const JOB_STATUS_CANCELED = 'Job Canceled';
export const JOB_STATUS_ALL = `All`;
export const JOB_STATUS_DEFAULT_FILTER = JOB_STATUS_DEFAULT_ACTIVE;

export const staticData = {
  bookTypes: ['Search Book', 'Review'],
  jobsStatus: [JOB_STATUS_DEFAULT_FILTER, JOB_STATUS_CANCELED, JOB_STATUS_COMPLETED, JOB_STATUS_ALL],
  jobsStatusShadow: [JOB_STATUS_DEFAULT_FILTER, JOB_STATUS_COMPLETED, JOB_STATUS_ALL],
  managementStrategies: [JOB_STATUS_DEFAULT_FILTER, 'Passive', 'Enhanced'],
  sourcesCandidates: ['Advertised Search', 'NEPC Best Thoughts', 'Focus Placement Lists'],
  feeTypes: [
    { value: 0, name: '' },
    { value: 5, name: 'Search Specific (SA)' },
    { value: 8, name: 'Search Specific (CF)' },
    { value: 9, name: 'Search Specific (MF)' },
  ],
  NEPC_CREATED_DS_ID: 5,
};
